import { Component, OnInit, NgZone, Input, ViewChild } from '@angular/core';
import { ModalController, Platform, ToastController, IonDatetime } from '@ionic/angular';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { StorageService } from '../../../../services/commons/storage.service';
import { GlobalVariablesService } from '../../../../services/global-variables.service';
import { HistoricalService } from '../../../../services/commons/historical.service';
import { AlarmLogRequest } from '../../../../services/SicorService/RequestObject/AlarmLogRequest';
import { AlarmLog } from '../../../../models/AlarmLog';
import { OcLogRequest } from '../../../../services/SicorService/RequestObject/OcLogRequest';
import { OcLog } from 'src/app/models/OcLog';
import { Historical } from 'src/app/models/Historical';
import { GlobalMethodsService } from '../../../../services/global-methods.service';
import * as moment from 'moment';
import { DefaultModalComponent } from '../../default-modal/default-modal.component';
import { TranslateConfigService } from 'src/app/services/commons/translate-config.service';
import { ModalService } from '../../../../services/commons/modal.service';
import { PhotosCamerasComponent } from 'src/app/components/modals/photos-cameras/photos-cameras.component';
import { CameraService } from 'src/app/services/commons/camera.service';
import { NavigationService } from '../../../../services/commons/navigation.service';
import { FirebaseCrashlytics } from '@capacitor-community/firebase-crashlytics';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationPushComponent } from '../../../notification-push/notification-push.component';
import { ToastService } from '../../../../services/commons/toast.service';
import { PushNotificationSchema } from '@capacitor/push-notifications';
import { registerPlugin } from '@capacitor/core';
import { Camera } from '../../../../models/Camera';
import { Geolocation } from '@capacitor/geolocation';
import { ImageNotificationRequest } from '../../../../services/SicorService/RequestObject/ImageNotificationRequest';
import { Loader } from "@googlemaps/js-api-loader";

const AppRatePlugin = registerPlugin<any>('AppRatePlugin');

@Component({
  selector: 'app-historical',
  templateUrl: './historical.component.html',
  styleUrls: ['./historical.component.scss'],
})
export class HistoricalComponent implements OnInit {

  @Input('data') data: string;
  public filterForm: FormGroup;
  public user: string;
  public alarmsLogList: AlarmLog[] = [];
  public ocLogList: OcLog[] = [];
  public historicalList: Historical[][] = [];
  public filterTp = 'XXXX ';
  public scrollDepthTriggered: boolean;
  public isDateFilterActive: boolean;
  public dateBegin: string = '';
  public dateEnd: string = '';
  public lastAlarmLog: AlarmLog = new AlarmLog();
  public lastOcLog: OcLog = new OcLog();
  public isServiceBusy = false;
  public todaysDate = '';
  public dataNotificationPush: any;
  private toastPresent = false;
  private initAlarmsLogList: AlarmLog[] = [];
  private initOcLogList: OcLog[] = [];
  private userPosition = { lat: 0, lng: 0 };
  public map: any;
  public marker: any;
  public coords = {
    latitude: 0,
    longitude: 0,
  };
  public tracker: any;
  public dateFrom = '';
  public dateTo = '';
  public openDateFilter: boolean;

  constructor(private modalCtrl: ModalController,
    private formBuilder: FormBuilder,
    private storage: StorageService,
    public gvs: GlobalVariablesService,
    private historicalService: HistoricalService,
    public gms: GlobalMethodsService,
    public toastController: ToastController,
    private defaultModalComponent: DefaultModalComponent,
    private translate: TranslateConfigService,
    public modalService: ModalService,
    public navigation: NavigationService,
    private cameraService: CameraService,
    public platform: Platform,
    private zone: NgZone,
    private toastService: ToastService,
    private router: Router,
    private activatedRouter: ActivatedRoute) {
  }

  async ngOnInit() {
    this.filterForm = this.formBuilder.group({
      date_since: new FormControl('', []),
      date_until: new FormControl('', []),
      connection_disconnection: new FormControl(true, []),
      alarms: new FormControl(true, []),
      request: new FormControl(true, []),
      power_outages: new FormControl(true, [])
      //maintenance: new FormControl(true, [])
    });

  }

  async ionViewWillEnter() {
    if(this.data != null && this.data != ''){
      await this.gms.setSetupPage(true, true, true, false);
    }
    this.gms.setLoadingTrue();
    this.gms.analyticsTrackEvent('openScreen', { screenName: 'Historico', contentGroup: 'Historico' });
    await this.gms.clearIntervalStatusInstallationEvent();
    this.user = this.gvs.user.userName;

    let today = new Date();
    let tenBehind = new Date(this.gms.restDaysToDate(today.getTime(), 10));
    this.gms.dateFormat(today, 'DD/MM/YY');
    try {
      this.initAlarmsLogList = await this.loadAlarmsLog(false, this.gms.dateFormat(today, 'DD/MM/YY'), this.gms.dateFormat(tenBehind, 'DD/MM/YY'), this.filterTp);
      this.initOcLogList = await this.loadOcLog(false, this.gms.dateFormat(today, 'DD/MM/YY'), this.gms.dateFormat(tenBehind, 'DD/MM/YY'));
      if (this.initAlarmsLogList.length === 0 && this.initOcLogList.length === 0){
        this.initAlarmsLogList = await this.loadAlarmsLog(false);
        this.initOcLogList = await this.loadOcLog(false);
      }
    } catch (e) {
      const message = JSON.stringify(e);
      this.gms.analyticsTrackEvent('register_search', { eventCategory: 'SICOR/Buscar Registro', eventAction: 'Error/Buscar Registro' });
      await FirebaseCrashlytics.recordException({ message: message });
      this.gms.setLoadingFalse();
    }
    let date = new Date();
    const mo = date.toLocaleString('default', { month: 'long' });
    let d = date.getDate() + ' ' + mo + ' ' + date.getFullYear();
    this.todaysDate = d;
    const historicalList = await this.loadHistorical(this.initAlarmsLogList, this.initOcLogList);
    // this.gms.setLoadingFalse();
   if(this.data != null && this.data != ''){
      this.openModalNotificationBurglary(this.data);
    }
  }

  async ionViewDidEnter() {
    this.gvs.modalLoaded = 'empty';
    // const historicalList = this.loadHistorical(this.initAlarmsLogList, this.initOcLogList);
    await this.loadOpenMaps();
    await this.gms.sleep(500);
    this.gms.setLoadingFalse();
  }

  dismiss(value) {
    this.modalService.hide('historicalModal', value)
  }

  togglePanel(element, historical?) {
    element.classList.toggle('open');
    if(historical != null){
      historical.value.forEach(reg => {
        if (reg.evnr === 4 && reg.misc7 != '' && reg.misc8 != ''
        && this.gms.validateCoords(historical.misc7) && this.gms.validateCoords(historical.misc8) && element.classList.contains('open')) {
          this.loadMap(reg);
        }
      });
    }else{
      if(element.classList.contains('open')){
        this.openDateFilter = true;
      }else{
        this.openDateFilter = false;
      }
    }
  }

  dateChange(date, source:string){
    moment.locale('es');
    if (source === 'since'){
      this.dateBegin = moment(date).format('L')
      this.dateFrom = date;
    }else if (source === 'until'){
      this.dateEnd = moment(date).format('L');
      this.dateTo = date;
    }
  }

  public async onSubmit() {
    if (this.isServiceBusy) {
      return;
    }
    if (this.filterForm.valid) {
      this.isServiceBusy = true;
      await this.gms.loading();
      this.isDateFilterActive = true;
      this.setFilterTp();
      if (this.filterForm.controls.date_since.value == null || this.filterForm.controls.date_since.value == '') {
        this.dateBegin = this.gms.dateFormat(new Date(), 'DD/MM/YYYY');
        this.dateFrom = this.gms.dateFormat(new Date(), 'YYYY-MM-DD');
      }
      if (this.filterForm.controls.date_until.value == null || this.filterForm.controls.date_until.value == '') {
        this.dateEnd = this.gms.dateFormat(new Date(), 'DD/MM/YYYY');
        this.dateTo = this.gms.dateFormat(new Date(), 'YYYY-MM-DD');
      }
      this.historicalList = [];
      this.alarmsLogList = [];
      this.ocLogList = [];
      const alarmsLogList = await this.loadAlarmsLog(true, moment(this.dateTo).format('DD/MM/YY'), moment(this.dateFrom).format('DD/MM/YY'), this.filterTp);
      let ocLogList: OcLog[] = [];
      if (this.filterForm.controls.connection_disconnection.value === true) {
        ocLogList = await this.loadOcLog(true, moment(this.dateTo).format('DD/MM/YY'), moment(this.dateFrom).format('DD/MM/YY'), 0);
      }
      const historicalList = await this.loadHistorical(alarmsLogList, ocLogList);
      this.modalCtrl.dismiss(false, '', 'loadSpinner');
      if (historicalList.length === 0) {
        await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleInfo'), await this.translate.getTranslate('MESSAGES.notFoundResult'),
          'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
      }
      this.isServiceBusy = false;
    } else {
      this.validateAllFormFields(this.filterForm);
    }
  }

  isFieldValid(field: string) {
    return !this.filterForm.get(field).valid && this.filterForm.get(field).touched;
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (!control.valid) {
        this.gms.analyticsTrackEvent('form_error', { eventCategory: 'SICOR/Registro', eventAction: 'Error/Form: Filtros Registro', eventLabel: 'Campo: ' + field });
      }
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  async loadAlarmsLog(btnFilter: boolean, dateBegin = '', dateEnd = '', filterTp = this.filterTp, timeBegin = '23:59:59', timeEnd = '00:00:00', tm = 0, seq = 0) {
    let tempAlarmsLogList: AlarmLog[] = [];
    const checkInternet = await this.gms.checkInternet();
    if (checkInternet) {
      const alarmLogRequest: AlarmLogRequest = new AlarmLogRequest(this.user, this.gvs.currentInstallation.s_ins, 250, dateBegin, dateEnd,
        filterTp, tm, seq, timeBegin, timeEnd);
      tempAlarmsLogList = await this.historicalService.getAlarmsLog(alarmLogRequest);
      if (tempAlarmsLogList != null) {
        if (tempAlarmsLogList.length > 0) {
          for (let i = 0; i < tempAlarmsLogList.length; i++) {
            this.alarmsLogList.push(tempAlarmsLogList[i]);
          }
        }
        if (btnFilter) {
          this.gms.analyticsTrackEvent('register_search', { eventCategory: 'SICOR/Buscar Registro', eventAction: 'Accion/Buscar Registro' });
        }
      } else {
        tempAlarmsLogList = <AlarmLog[]>[];
        if (btnFilter) {
          this.gms.analyticsTrackEvent('register_search', { eventCategory: 'SICOR/Buscar Registro', eventAction: 'Error/Buscar Registro' });
        }
      }
    } else {
      this.modalCtrl.dismiss(false, '', 'historicalModal');
      await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.noInternetConnection'),
        'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
    }
    return tempAlarmsLogList;
  }

  async loadOcLog(btnFilter, dateBegin = '', dateEnd = '', filterTp = 0, timeBegin = '23:59:59', timeEnd = '00:00:00', tm = 0, seq = 0) {
    let tempOcLogList: OcLog[] = [];
    const checkInternet = await this.gms.checkInternet();
    if (checkInternet) {
      const ocLogRequest: OcLogRequest = new OcLogRequest(this.user, this.gvs.currentInstallation.s_ins, 250, dateBegin, dateEnd,
        filterTp, tm, seq, timeBegin, timeEnd);
      tempOcLogList = await this.historicalService.getOcLog(ocLogRequest);
      if (tempOcLogList != null) {
        if (tempOcLogList.length > 0) {
          for (let i = 0; i < tempOcLogList.length; i++) {
            this.ocLogList.push(tempOcLogList[i]);
          }
        }
        if (btnFilter) {
          this.gms.analyticsTrackEvent('register_search', { eventCategory: 'SICOR/Buscar Registro', eventAction: 'Accion/Buscar Registro' });
        }
      } else {
        tempOcLogList = <OcLog[]>[];
        if (btnFilter) {
          this.gms.analyticsTrackEvent('register_search', { eventCategory: 'SICOR/Buscar Registro', eventAction: 'Error/Buscar Registro' });
        }
      }
    } else {
      await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.noInternetConnection'),
        'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
    }
    return tempOcLogList;
  }

  async loadHistorical(alarmsLogList: AlarmLog[], ocLogList: OcLog[]) {
    let tempHistoricalList: Historical[] = [];

    if (alarmsLogList.length > 0) {
      for (let i = 0; i < alarmsLogList.length; i++) {
        let tempHistorical: Historical = new Historical();
        tempHistorical.setHistorical(alarmsLogList[i].tm, alarmsLogList[i].seq, alarmsLogList[i].tm_date,
          alarmsLogList[i].tm_time, alarmsLogList[i].evnr, alarmsLogList[i].area, alarmsLogList[i].text.trim(), 'alarmlog',
          alarmsLogList[i].alid, alarmsLogList[i].comm_gen, alarmsLogList[i].misc10, alarmsLogList[i].misc6,
          alarmsLogList[i].misc7, alarmsLogList[i].misc8);
        tempHistoricalList.push(tempHistorical);
      }
    }

    if (ocLogList.length > 0) {
      for (let i = 0; i < ocLogList.length; i++) {
        let tempHistorical: Historical = new Historical();
        tempHistorical.setHistorical(ocLogList[i].tm, ocLogList[i].seq, ocLogList[i].date,
          ocLogList[i].time, ocLogList[i].evnr_type, ocLogList[i].user_name.trim() !== '' ? ocLogList[i].user_name.trim() : ocLogList[i].user_field.trim(), ocLogList[i].type.trim(), 'oclog');
        tempHistoricalList.push(tempHistorical);
      }
    }

    if (tempHistoricalList.length > 0) {
      tempHistoricalList.sort(function (a, b) {
        return moment(b.date, "DD/MM/YY").valueOf() - moment(a.date, "DD/MM/YY").valueOf();
      });
      for (let i = 0; i < tempHistoricalList.length; i++) {
        let nowDate = this.gms.parseDateMoment(tempHistoricalList[i].date.toString(), 'DD/MM/YY');
        let now = this.gms.dateFormat(nowDate, 'D') + ' ' + this.gms.dateFormat(nowDate, 'MMMM') + ' ' + this.gms.dateFormat(nowDate, 'YYYY');
        if (!this.historicalList[now]) {
          this.historicalList[now] = [tempHistoricalList[i]];
        }
        else {
          this.historicalList[now].push(tempHistoricalList[i]);
        }
        this.historicalList[now].sort(function (a, b) {
          return moment(b.date + " " + b.time, "DD/MM/YY HH:mm:ss").valueOf() - moment(a.date + " " + a.time, "DD/MM/YY HH:mm:ss").valueOf();
        });
      }
    }
    await this.loadOpenMaps();
    return tempHistoricalList;
  }

  returnZero() {
    return 0;
  }

  setFilterTp() {
    if (this.filterForm.controls.connection_disconnection.value === false) {
      this.filterTp = this.gms.replaceAt(this.filterTp, 0, ' ');
    } else {
      this.filterTp = this.gms.replaceAt(this.filterTp, 0, 'X');
    }
    if (this.filterForm.controls.alarms.value === false) {
      this.filterTp = this.gms.replaceAt(this.filterTp, 1, ' ');
    } else {
      this.filterTp = this.gms.replaceAt(this.filterTp, 1, 'X');
    }
    if (this.filterForm.controls.request.value === false) {
      this.filterTp = this.gms.replaceAt(this.filterTp, 2, ' ');
    } else {
      this.filterTp = this.gms.replaceAt(this.filterTp, 2, 'X');
    }
    if (this.filterForm.controls.power_outages.value === false) {
      this.filterTp = this.gms.replaceAt(this.filterTp, 3, ' ');
    } else {
      this.filterTp = this.gms.replaceAt(this.filterTp, 3, 'X');
    }
    //TO DO: Sicor ha pedido ocultar los mantenimientos
    /*if (this.filterForm.controls.maintenance.value === false) {
      this.filterTp = this.gms.replaceAt(this.filterTp, 4, ' ');
    } else {
      this.filterTp = this.gms.replaceAt(this.filterTp, 4, 'X');
    }*/
  }

  async logScrolling($event) {
    if (this.scrollDepthTriggered) {
      return;
    }
    const scrollHeight = $event.target.scrollHeight - $event.target.clientHeight;
    const currentScrollDepth = $event.target.scrollTop;
    const targetPercent = 99.91;
    const triggerDepth = ((scrollHeight / 100) * targetPercent);
    if (currentScrollDepth > triggerDepth) {
      this.scrollDepthTriggered = true;
      await this.requestMoreRegisters();
      this.scrollDepthTriggered = false;
    }
  }

  async requestMoreRegisters() {
    const alarmLog: AlarmLog = this.alarmsLogList[this.alarmsLogList.length - 1];
    const ocLog: OcLog = this.ocLogList[this.ocLogList.length - 1];
    if (((alarmLog != null && alarmLog.tm !== this.lastAlarmLog.tm) || (alarmLog != null && alarmLog.seq !== this.lastAlarmLog.seq))
      || ((ocLog != null && ocLog.tm !== this.lastOcLog.tm) || (ocLog != null && ocLog.seq !== this.lastOcLog.seq))) {
      await this.gms.loading();
      let alarmsLogList: AlarmLog[] = [];
      let ocLogList: OcLog[] = [];
      try {
        if (alarmLog != null) {
          alarmsLogList = await this.loadAlarmsLog(false, '', '', this.filterTp, moment(alarmLog.tm_time, 'HH:mm:ss').format('HH:mm:ss'), '00:00:00', alarmLog.tm, alarmLog.seq);
        } else {
          alarmsLogList = await this.loadAlarmsLog(false);
        }
        if (ocLog != null) {
          ocLogList = await this.loadOcLog(false, '', '', 0, moment(ocLog.time, 'HH:mm:ss').format('HH:mm:ss'), '00:00:00', ocLog.tm, ocLog.seq);
        } else {
          ocLogList = await this.loadOcLog(false);
        }
      } catch (e) {
        const message = JSON.stringify(e);
        await FirebaseCrashlytics.recordException({ message: message });
        this.modalCtrl.dismiss(false, '', 'loadSpinner');
      }
      await this.loadHistorical(alarmsLogList, ocLogList);
      this.lastAlarmLog = alarmLog;
      this.lastOcLog = ocLog;
      this.modalCtrl.dismiss(false, '', 'loadSpinner');
    } else {
      this.presentToast();
    }

  }

  clickResetDate() {
    this.filterForm.controls['date_since'].setValue('');
    this.filterForm.controls['date_until'].setValue('');
  }

  // View Photo/Video button

  async viewCamerasAccess(alarmLog: Historical) {
    const checkInternet = await this.gms.checkInternet();
    if (checkInternet) {
      let format = '';
      switch (alarmLog.misc10.toLowerCase()) {
        case 'jpg':
          format = 'FOTOS';
          break;
        case 'mp4':
          format = 'VIDEO';
          break;
        default:
          format = 'CAMERA';
          break;
      }
      if (format !== 'CAMERA') {
        this.gms.loading();
        let resources;
        let resourcesNotReady: number;
        let timeLimit = 0;
        do {
          resourcesNotReady = 0;
          resources = await this.cameraService.downloadPhotoVideo(this.user, this.gvs.currentInstallation.s_ins, format, alarmLog.alid, alarmLog.comm_gen, 'historical');
          if (resources.length === 0) {
            await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.resourceNotAvailable'),
              'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
            this.modalCtrl.dismiss(false, '', 'loadSpinner');
            return;
          }
          resources.forEach(resource => {
            if (resource.doc_url.indexOf('http://') !== -1 || resource.doc_url.indexOf('https://') !== -1) {
              resourcesNotReady = resourcesNotReady + 1;
            }
          });
          timeLimit++;
          await this.gms.sleep(1000);
        } while (resourcesNotReady > 0 && resourcesNotReady != resources.length && timeLimit < 15)
        this.modalCtrl.dismiss(false, '', 'loadSpinner');
        if (timeLimit >= 15) {
          await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.resourceNotAvailable'),
            'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
          return;
        }
        if (resources != null && resources[0].doc_url !== '') {
          const contentModal = await this.modalCtrl.create({
            component: PhotosCamerasComponent,
            componentProps: { format: format, resources: resources, descCamera: alarmLog.name },
            cssClass: ['w-modal-lg', 'padding-lg', 'photos-historical-modal'],
          });

          contentModal.onDidDismiss().then(data => {
            this.zone.run(() => {
              if (!this.platform.is("desktop") && !this.platform.is("mobileweb") && this.gvs.ratingAvailable) {
                AppRatePlugin.customRatingCall();
                this.gvs.ratingAvailable = false;
              }
            });
          });

          contentModal.present().then();
        } else {
          await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleInfo'), await this.translate.getTranslate('MESSAGES.notFoundPhotoVideo'),
            'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
        }
      } else {
        return;
      }
    } else {
      await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.noInternetConnection'),
        'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
    }
  }

  // async doRefresh($ev) {
  //   this.historicalList = [];
  //   this.alarmsLogList = [];
  //   this.ocLogList = [];
  //   await this.loadAlarmsLog(false, '', '', this.filterTp);
  //   await this.loadOcLog(false);
  //   await this.loadHistorical(this.alarmsLogList, this.ocLogList);
  //   $ev.target.complete();
  // }

  async openModalNotificationBurglary(data: any) {
    let imageNotificationRequest: ImageNotificationRequest = new ImageNotificationRequest(data.email, data.s_ins, data.s_inc);
    let imageBase64 = await this.historicalService.getImageNotification(imageNotificationRequest);
    const contentModal = await this.modalCtrl.create({
      component: NotificationPushComponent,
      id: 'modalNotificationPush',
      componentProps: { description: data.comm_log, image: imageBase64 != null && imageBase64 !== '' ? imageBase64 : '' },
      cssClass: ['w-modal-md-dark'],
    });

    contentModal.onDidDismiss().then(data => {
      this.zone.run(() => {
      });
    });

    contentModal.present().then();
  }

  openToast() {
    let notification: PushNotificationSchema;
    this.toastService.showPush(notification, (notification) => { });
  }

  async presentToast() {
    if (!this.toastPresent) {
      this.toastPresent = true;
      const message = await this.translate.getTranslate('MESSAGES.noMoreRegisters');
      const toast = await this.toastController.create({
        message,
        cssClass: 'toasty-sicor',
        position: 'top',
        duration: 2000
      });
      toast.present();

      toast.onDidDismiss().then(response => {
        this.toastPresent = false;
      });
    }
  }

  async loadMap(historicalRegister: Historical) {
    const loader = new Loader({
      apiKey: "AIzaSyCYyTGACNCpS7V87Sp0hnRwr427RJ6bvGU",
      version: "weekly"
    });

    let coords = {
      latitude: parseFloat(historicalRegister.misc7),
      longitude: parseFloat(historicalRegister.misc8),
    };

    await loader.load().then(async (google) => {
      let userPosition = { lat: coords.latitude, lng: coords.longitude };
      let map = new google.maps.Map(document.getElementById(historicalRegister.seq.toString()) as HTMLElement, {
        center: userPosition,
        zoom: 15,
        disableDefaultUI: true,
        draggable: false,
        clickableIcons: false
      });

      // const image = {
      //   url: "/assets/resources/circle.png",
      //   size: new google.maps.Size(50, 50),
      //   origin: new google.maps.Point(0, 0),
      //   anchor: new google.maps.Point(0, 0),
      //   // scaledSize: new google.maps.Size(50, 50), // scaled size
      // };

      let marker = new google.maps.Marker({
        position: userPosition,
        map: map,
        icon: "/assets/resources/circle.png"
      });
    });
  }

  public async loadOpenMaps(){
    await this.gms.sleep(500);
    if (this.historicalList[this.todaysDate]) {
      this.historicalList[this.todaysDate].forEach(historical => {
        if (historical.evnr === 4 && historical.misc7 != '' && historical.misc8 != ''
          && this.gms.validateCoords(historical.misc7) && this.gms.validateCoords(historical.misc8)) {
          this.loadMap(historical);
        }
      });
    }
  }

  public openDetail(historical: Historical) {
    if (historical.evnr === 4) {
      if (historical.misc7 != null && historical.misc7 != '' && historical.misc8 != null && historical.misc8 != '') {
        let coords = {
          latitude: parseFloat(historical.misc7),
          longitude: parseFloat(historical.misc8),
        };
        if (this.platform.is('android')) {
          window.location.href = "http://maps.google.com/maps?&geo=" + coords.latitude + "," + coords.longitude + "&q=" + coords.latitude + "," + coords.longitude;
        } else if (this.platform.is('ios')) {
          window.location.href = "http://maps.apple.com/?q=" + coords.latitude + "," + coords.longitude + "&ll=" + coords.latitude + "," + coords.longitude;
        } else if (this.platform.is('desktop')) {
          window.open("http://maps.google.com/maps?&geo=" + coords.latitude + "," + coords.longitude + "&q=" + coords.latitude + "," + coords.longitude, '_blank');
        } 
      }
    } else if (historical.evnr === 130 && historical.misc6 && historical.misc6 != '' && historical.misc6 != 'GPS') {
      this.viewCamerasAccess(historical);
    }
  }
}
